import { useEffect } from 'react';
// @mui
import { Box, Stack, Drawer, Divider, Button } from '@mui/material';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// components
import { Logo, LogoDark, SingleLogo } from 'src/components/logo';
import Scrollbar from 'src/components/scrollbar';
import { usePathname, useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
import { NavSectionVertical } from 'src/components/nav-section';
import { useSelector } from 'src/store';
import { MenuIcon } from 'src/assets/icons';

//
import { useNavData, useLockNavData } from './config-navigation';
import { NavToggleButton, NavUpgrade, NavFooter } from '../_common';
import { HEADER, NAV } from '../config-layout';

// ----------------------------------------------------------------------

type Props = {
  openNav: boolean;
  onCloseNav: VoidFunction;
};

export default function NavVertical({ openNav, onCloseNav }: Props) {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const { name } = useSelector((state) => state.drawer);

  const router = useRouter();
  const pathName = usePathname();

  const lgUp = useResponsive('up', 'lg');

  const navData = useNavData();
  const lockNavData = useLockNavData();

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathName]);

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        paddingTop: 2,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      {/* {isLoggedIn && <NavUpgrade />} */}

      {/* <Divider sx={{ mb: 1 }} /> */}

      <NavSectionVertical
        data={isLoggedIn ? navData : lockNavData}
        config={{
          currentRole: 'admin',
        }}
      />

      {/* {isLoggedIn && <Divider />}

      {isLoggedIn && <NavFooter />} */}

      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        minHeight: '100vh',
        width: { lg: NAV.W_VERTICAL },
        zIndex: name ? 1201 : 100,
        // boxShadow: '0 .5rem 1rem rgba(0,0,0,.15)',
        position: 'fixed',
        backgroundColor: 'rgb(9 9 21)',
      }}
    >
      {lgUp ? (
        <Stack
          sx={{
            height: 1,
            position: 'fixed',
            width: NAV.W_VERTICAL,
            // borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            height={HEADER.H_MOBILE}
            px={2}
            borderBottom="1px solid #dfd7d729 !important"
          >
            <NavToggleButton />
            <SingleLogo />
            {/* <Stack
              direction="row"
              gap={0.5}
              p={0.4}
              sx={{ background: '#ededee', border: 'solid 0.5px #e1e1e1', borderRadius: 1 }}
            >
              <Button
                variant={pathName === paths.dashboard.casino ? 'soft' : 'text'}
                onClick={() => router.push(paths.dashboard.casino)}
                sx={{
                  width: '70px',
                  ...(pathName === paths.dashboard.casino && { backgroundColor: '#919eab3d' }),
                }}
              >
                Casino
              </Button>
              <Button
                variant={pathName === paths.dashboard.liveCasino ? 'soft' : 'text'}
                onClick={() => router.push(paths.dashboard.liveCasino)}
                sx={{
                  width: '70px',
                  ...(pathName === paths.dashboard.liveCasino && { backgroundColor: '#919eab3d' }),
                }}
              >
                Live
              </Button>
            </Stack> */}
          </Stack>

          {renderContent}
        </Stack>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          PaperProps={{
            sx: {
              width: NAV.W_VERTICAL,
              backgroundColor: 'rgb(9 9 21) !important',
            },
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            height={HEADER.H_MOBILE}
            px={2}
            borderBottom="1px solid #dfd7d729 !important"
          >
            <MenuIcon style={{ cursor: 'pointer', width: 43 }} onClick={()=>onCloseNav()} />
            <SingleLogo />
          </Stack>

          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
